import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { LicensePortalState, SubmitLicenseRequestBody, PendingApproval, ManagerDecisionBody, ApprovedLicense, RevokeLicenseBody } from '@app/core/models';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LicensePortalApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.experienceApi.url.replace(/\/$/, '');

  getState(): Observable<LicensePortalState> {
    return this.http.get<LicensePortalState>(`${this.baseUrl}/v1/licenses`).pipe(
      catchError((e) => this.mapError(e))
    );
  }

  submitRequest(body: SubmitLicenseRequestBody): Observable<LicensePortalState> {
    return this.http
      .post<LicensePortalState>(`${this.baseUrl}/v1/licenses/request`, body)
      .pipe(catchError((e) => this.mapError(e)));
  }

  getPendingApprovals(): Observable<PendingApproval[]> {
    return this.http.get<PendingApproval[]>(`${this.baseUrl}/v1/licenses/pending-approvals`).pipe(
      catchError((e) => this.mapError(e))
    );
  }

  submitDecision(body: ManagerDecisionBody): Observable<unknown> {
    return this.http
      .post(`${this.baseUrl}/v1/licenses/decision`, body)
      .pipe(catchError((e) => this.mapError(e)));
  }

  getAdminLicenses(): Observable<ApprovedLicense[]> {
    return this.http.get<ApprovedLicense[]>(`${this.baseUrl}/v1/licenses/admin/licenses`).pipe(
      catchError((e) => this.mapError(e))
    );
  }

  revokeLicense(body: RevokeLicenseBody): Observable<unknown> {
    return this.http
      .post(`${this.baseUrl}/v1/licenses/admin/revoke`, body)
      .pipe(catchError((e) => this.mapError(e)));
  }

  private mapError(err: unknown): Observable<never> {
    if (err instanceof HttpErrorResponse) {
      const body = err.error;
      let msg = err.message;
      if (typeof body === 'object' && body && 'detail' in body) {
        msg = String((body as { detail?: string }).detail);
      } else if (typeof body === 'string' && body.length) {
        msg = body;
      }
      return throwError(() => new Error(msg || `HTTP ${err.status}`));
    }
    return throwError(() => (err instanceof Error ? err : new Error(String(err))));
  }
}
